import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { RadioButton } from '../../../../components/RadioButton';
import { StyledRadioLabelText } from '../../../../components/RadioButton/styles';

export const StyledCountriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 16px;
`;

export const StyledRadioButton = styled(RadioButton)`
  padding: 12px;
  background-color: ${colorsPalettes.carbon[0]};
  width: 100%;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ selected }) => (selected ? colorsPalettes.blue[400] : colorsPalettes.carbon[0])};
  transition: border-color 0.3s ease-in-out;

  ${StyledRadioLabelText} {
    ${setFontVariant('subTitle3Alt', colorsPalettes.carbon[300])};
    line-height: 20px;
    display: inline-flex;
    justify-content: space-between;
    flex-grow: 1;
  }
`;

export const StyledCountrySelectionList = styled.div<{ isVisible: boolean }>`
  width: 100%;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out 0.3s;
  margin-top: -14px;
`;

export const StyledCountriesListLabel = styled.div`
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  margin: 38px 0 2px;
  ${setFontVariant('subTitle3Alt', colorsPalettes.carbon[300])};
  line-height: 20px;
`;
